var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyFavourite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 80.2232,
    cy: 80.7589,
    r: 47.0089,
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 27.5893,
    cy: 67.4999,
    r: 10.7143,
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 48.2143,
    cy: 24.6427,
    r: 6.69643,
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 122.009,
    cy: 33.3482,
    r: 5.22321,
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 120.402,
    cy: 111.83,
    r: 2.54464,
    fill: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M92.4769 36.3454C92.2772 36.303 92.2772 36.018 92.4769 35.9756L95.4957 35.3336C95.5684 35.3181 95.6253 35.2614 95.6411 35.1887L96.2911 32.1912C96.3342 31.9925 96.6176 31.9925 96.6607 32.1912L97.3106 35.1887C97.3264 35.2614 97.3833 35.3181 97.4561 35.3336L100.475 35.9756C100.675 36.018 100.675 36.303 100.475 36.3454L97.4561 36.9874C97.3833 37.0029 97.3264 37.0596 97.3106 37.1323L96.6607 40.1298C96.6176 40.3285 96.3342 40.3285 96.2911 40.1298L95.6411 37.1323C95.6253 37.0596 95.5684 37.0029 95.4957 36.9874L92.4769 36.3454Z",
    fill: "#F8AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M24.8332 86.8132C24.8932 86.53 25.2974 86.53 25.3574 86.8132L26.2527 91.0434C26.2746 91.1465 26.3548 91.2272 26.4578 91.2496L30.6443 92.1616C30.9254 92.2229 30.9254 92.6238 30.6443 92.6851L26.4578 93.5971C26.3548 93.6195 26.2746 93.7002 26.2527 93.8033L25.3574 98.0335C25.2974 98.3167 24.8932 98.3167 24.8332 98.0335L23.9379 93.8033C23.916 93.7002 23.8358 93.6195 23.7328 93.5971L19.5463 92.6851C19.2652 92.6238 19.2652 92.2229 19.5463 92.1616L23.7328 91.2496C23.8358 91.2272 23.916 91.1465 23.9379 91.0434L24.8332 86.8132Z",
    fill: "#F8AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 3",
    d: "M92.5929 123.737C92.6528 123.454 93.057 123.454 93.117 123.737L93.6393 126.205C93.6612 126.308 93.7414 126.389 93.8444 126.411L96.2937 126.945C96.5748 127.006 96.5748 127.407 96.2937 127.468L93.8444 128.002C93.7414 128.024 93.6612 128.105 93.6393 128.208L93.117 130.676C93.057 130.959 92.6528 130.959 92.5929 130.676L92.0705 128.208C92.0487 128.105 91.9685 128.024 91.8655 128.002L89.4162 127.468C89.1351 127.407 89.1351 127.006 89.4162 126.945L91.8655 126.411C91.9685 126.389 92.0487 126.308 92.0705 126.205L92.5929 123.737Z",
    fill: "#F8AFAF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M130.58 52.054L97.7977 45.7722C96.3448 45.4938 94.9413 46.4459 94.6629 47.8988L86.2636 91.7311C86.1052 92.5578 86.3446 93.4108 86.9099 94.0343L102.144 110.838C103.029 111.814 104.491 112.002 105.594 111.281L123.349 99.6779C123.957 99.2805 124.378 98.6532 124.515 97.9398L132.707 55.1888C132.985 53.7359 132.033 52.3324 130.58 52.054Z",
    fill: "#F8AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M107.382 61.2064C104.957 60.6883 102.574 62.2147 102.061 64.6164C101.647 66.5551 101.432 71.3206 108.005 77.5883C108.123 77.6998 108.269 77.7766 108.427 77.8105C108.586 77.8444 108.751 77.834 108.904 77.7805C117.464 74.7455 119.216 70.3084 119.63 68.3697C120.143 65.9681 118.592 63.6012 116.166 63.0831C113.741 62.5649 111.211 64.7801 111.211 64.7801C111.211 64.7801 109.807 61.7246 107.382 61.2064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 104.732,
    cy: 99.9109,
    r: 3.48214,
    fill: "#FFE7E7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tag 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2_2",
    d: "M69.0547 31.6608L25.3595 47.4874C23.6904 48.092 22.8274 49.9351 23.4319 51.6042L44.2309 109.028C44.5748 109.977 45.3451 110.71 46.3108 111.006L76.4969 120.262C78.0079 120.725 79.6315 120.021 80.3262 118.601L93.3106 92.0704C93.6938 91.2874 93.7425 90.3824 93.4457 89.5628L73.1715 33.5884C72.567 31.9193 70.7238 31.0563 69.0547 31.6608Z",
    fill: "url(#paint0_linear_276_19938)",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1_2",
    d: "M54.9436 59.3234C54.9436 59.3234 54.9436 59.3234 54.9436 59.3233L54.9437 59.3231L54.944 59.322L54.9463 59.3138L54.9569 59.2774C54.9666 59.2444 54.9817 59.1943 55.0024 59.1293C55.0438 58.9992 55.1074 58.8095 55.1948 58.5765C55.3698 58.1097 55.6383 57.4739 56.0115 56.7985C56.7676 55.43 57.9065 53.9832 59.4899 53.3619C62.7341 52.0888 66.3776 53.6624 67.6334 56.8626C68.1565 58.1956 68.7892 60.5803 68.2787 63.9824C67.7676 67.3879 66.1058 71.8464 61.9861 77.3151C61.8967 77.4322 61.7769 77.5226 61.6397 77.5765C61.5025 77.6303 61.3531 77.6455 61.2079 77.6204C54.4684 76.4129 50.218 74.2744 47.5273 72.1254C44.8393 69.9784 43.6814 67.7998 43.1583 66.4668C41.9025 63.2666 43.5035 59.6351 46.7477 58.362C48.3311 57.7407 50.15 58.0268 51.635 58.5159C52.368 58.7573 52.9972 59.0407 53.443 59.2639C53.6655 59.3753 53.8411 59.4711 53.96 59.5384C54.0194 59.572 54.0645 59.5984 54.0941 59.6159L54.1266 59.6355L54.1338 59.6399L54.1348 59.6405C54.1349 59.6405 54.135 59.6406 54.135 59.6406L54.1351 59.6407L54.1351 59.6407C54.1351 59.6407 54.1351 59.6407 54.1351 59.6407C54.2804 59.7308 54.4597 59.7471 54.6188 59.6846C54.778 59.6221 54.8984 59.4883 54.9436 59.3234Z",
    fill: "#F8AFAF",
    stroke: "#F8AFAF",
    strokeWidth: 1.08421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse ",
    cx: 72.1875,
    cy: 105.134,
    r: 4.41964,
    fill: "#F8AFAF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_276_19938",
    x1: 47.3895,
    y1: 40.0778,
    x2: 76.7622,
    y2: 121.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFavourite);
export default __webpack_public_path__ + "static/media/empty_favourite.bcd1aa899a49e166b9bce4f394b198fc.svg";
export { ForwardRef as ReactComponent };